<template>
  <div id="aboutLnt">
    <div v-if="selectedTab=='companyOverview'" class="container" id="aboutUs">
      <div class="row m-0 p-0">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">COMPANY OVERVIEW</h3>
        </div>
      </div>
      <div class="row animate-area">
        <div class="col-sm-5 aboutImg">
          <img src="@/assets/home-page-images/About1.png" alt />
        </div>
        <div class="col-sm-7 cardTxt">
          <p class="pt-5 pr-5 font-weight-bold">
            Larsen & Toubro is a major technology, engineering, construction,
            manufacturing and financial services conglomerate, with global
            operations. L&T addresses critical needs in key sectors -
            Hydrocarbon, Infrastructure, Power, Process Industries and
            Defense - for customers in over 30 countries around the world.
          </p>
          <p class="pr-5 font-weight-bold">
            L&T is engaged in core, high impact sectors of the economy and our
            integrated capabilities span the entire spectrum of ‘design to deliver’.
            With over 7 decades of a strong, customer focused approach and a
            continuous quest for world-class quality, we have unmatched expertise
            across Technology, Engineering, Construction, Infrastructure Projects
            and Manufacturing, and maintain a leadership in all our major
            lines of business.
          </p>
          <p class="pr-5 font-weight-bold">
            <a href="#">Learn More</a>
          </p>
        </div>
      </div>
    </div>
    <div v-if="selectedTab=='featuredProjects'" class="container" id="ftrPrjct">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="text-left stretched-side-headings">FEATURED PROJECTS</h3>
        </div>
      </div>
      <div class="row animate-area">
        <!-- <swiper class="font-weight-bold" :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Mumbai International Airport</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Terminal 2 built by L&T in the middle of fully functioning airport without disrupting airport operations</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Caters to 40 million passengers and a million tons of air cargo a year</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Features a new passenger terminal of close to 4.5 lakh sq. ft.</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Reconstruction and widening of 6.5 km of runways, 3 parallel taxiways, 10 million sq. ft of hard stands, taxiways, aprons for wide-bodied aircraft and associated support buildings</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/mumbaiAirport.jpg" alt />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Motera, Stadium</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >The world’s largest cricket stadium that can seat 110,000 people is in the making!</li>

                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >It will be replete with a clubhouse, a swimming pool of Olympic standards, an indoor cricket academy, presidential and special corporate boxes and a podium level to give spectators a 360 degree viewing opportunity</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/motera.jpg" alt />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">ITC Colombo</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >A two-tower behemoth, ITC Colombo will have a hotel tower of 29 floors and 371 rooms</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >A residential tower of 49 floors and 143 high-end residential units bordered by the Indian Ocean and a lake on either side</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >A 54 m sky bridge will link the two towers and is all set to redefine the Colombo skyline</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/ITC.jpg" alt />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Delhi Metro</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Played a lead role in implementing Phases 1 and 2 of the Delhi Metro</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Certified by the United Nations in 2011 as the first metro rail and rail-based system in the world to get carbon credits for reducing greenhouse gas emissions, helping reduce pollution in the city by 630,000 tonnes every year</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/DelhiMetro.jpg" alt />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Apollo Reach Hospital, Ayanambakkam, Chennai</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >A 200-bed facility, spread over 16,800 sq.m., this advanced speciality care centre, designed and built for Apollo Hospitals.</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Supported with diagnostic facilities like CT scans, MRI, X-ray, Ultrasound, Mammography, ECG, Treadmill, Echocardiography and PFT.</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/Apollo.jpg" alt />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Sewage Treatment Plant at Jebel Ali</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >375 MLD Sewage Treatment Plant is the largest Sewage Treatment Plant at Jebel Ali</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >The Sludge Treatment Process includes Sludge Thickening (Rotary Drums & Belt Thickeners), Anaerobic Digestion, Dewatering (Centrifuge), Sludge Drying (Thermal paddle dryers) facilities and Robotic Bagging System</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/SewagePlant.jpg" alt />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="row">
              <div class="col-4 p-0 cardTxt">
                <h3 class="ftrHeading text-left px-4">Minerva, Mumbai</h3>
                <Ul class="ml-4" style="margin-left:70px">
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Lokhandwala Minerva at Mahalaxmi, Mumbai is an 82-floor,307-meter&nbsp;skyscraper under construction that will crown the bay with its magnificent towers</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >The giant structure will have parking floors from 2nd to 16th</li>
                  <li
                    class="pHeading mt-2 font-weight-bold text-left"
                  >Podium garden on 17th floor, residential floors on 26th to 79th, a service floor on 80th and penthouses on 81st, 82nd and terrace</li>
                </Ul>
                <p>
                  <a class="px-4" href="#">Learn More</a>
                </p>
                <div class="row">
                  <div class="col-4 ml-4 mt-4">
                    <div class="swiper-button-prev ml-1 px-4" slot="button-prev"></div>
                    <div class="swiper-button-next pr-4" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-8 aboutImg">
                <img src="@/assets/home-page-images/Minerva.jpg" alt />
              </div>
            </div>
          </swiper-slide>
        </swiper>-->
      </div>
    </div>
    <div v-if="selectedTab=='partnershipAvenue'" class="container" id="partner">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">PARTNERSHIP AVENUES</h3>
        </div>
      </div>
      <div class="row animate-area">
        <div class="col-sm-8 aboutImg">
          <img src="@/assets/home-page-images/partner.png" alt />
        </div>
        <div class="col-sm-4 cardTxt text-left">
          <div class="m-auto">
            <ul>
              <li class="font-weight-bold">
                <h3>Buildings and Factories</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Transportation Infrastructure</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Minerals & Metals</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Heavy Civil</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Power transmission and Distribution</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Smart Cities</h3>
              </li>
              <li class="font-weight-bold">
                <h3>Water and Effluent treatment</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedTab=='Partner Overview'" class="container" id="mplace">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="text-left stretched-side-headings">PORTAL OVERVIEW</h3>
        </div>
      </div>
      <div class="row animate-area font-weight-bold">
        <div class="col-sm-4 cardTxt text-left">
          <p
            class="font-weight-bold"
          >Partner Portal - on demand market intelligence - will serve as high quality source of information, for all stakeholders to improve efficiency and performance.</p>
          <p
            class="font-weight-bold"
          >Product is designed to evaluate & on board elite partners to engage in prolific business with L&T.</p>
          <h3 class="mHeading">Salient features of this product from partner perspective</h3>
          <ul>
            <li>- Unique partner ID to deliver supply and services across divsions of L&T.</li>
            <li>- Quick Partner on boarding.</li>
            <li>- L&T Brand reinforcement.</li>
            <li>- Systematic performance evaluation of partners.</li>
            <li>- Risk Assessment with mitigation plan.</li>
            <li>- Provision to upload Product catalogues by partners in respone to L&T’s requirement.</li>
            <li>- To share their new avenues of business.</li>
            <li>- Register bills online and track status of procurement and service rendered by partners.</li>
            <li>- Provision to register Partners feedback towards ensuring sustained relationships.</li>
          </ul>
        </div>

        <div class="col-sm-8 aboutImg">
          <img src="@/assets/home-page-images/Overview.jpg" alt />
        </div>

        <!-- <div class="col-sm-4 aboutImg">
          <img src="@/assets/home-page-images/Mplace.png" alt />
        </div>-->
      </div>
    </div>
    <div v-if="selectedTab=='Partner With LandT'" class="container" id="Wpartner">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">PARTNER WITH L&T</h3>
        </div>
      </div>
      <div class="row animate-area">
        <div class="col-sm-8 aboutImg">
          <img src="@/assets/home-page-images/Wpartner.jpg" alt />
        </div>
        <div class="col-sm-4 cardTxt">
          <!-- <p
            class="pt-4 font-weight-bold"
          >L&T values the relationships that we have with our Partners and we view each one of them as a critical part of our team. At L&T, we realize our Partners play an important role in our success as a company and in the successes of our clients and projects.</p>-->
          <h3 class="mt-5 font-weight-bold text-left">Benefits</h3>
          <p
            class="font-weight-bold"
          >A business supported by partners with multiple talents and visions significantly increases opportunities to</p>
          <ul>
            <li class="pHeading mt-2 font-weight-bold text-left">Acquire New Customers</li>
            <li class="pHeading mt-2 font-weight-bold text-left">Increase Revenue</li>
            <li class="pHeading mt-2 font-weight-bold text-left">Expand Geographic Reach</li>
            <li class="pHeading mt-2 font-weight-bold text-left">Extend Product Lines</li>
            <li class="pHeading mt-2 font-weight-bold text-left">Access New Technologies and IP</li>
          </ul>
          <p
            class="font-weight-bold"
          >Creating a partnership also enhances motivation, morale and personal responsibility.</p>
          <!-- <h4 class="ftrHeading mt-5 text-left">
            "If everyone is moving forward together, then success takes care of itself."
            <br />--Henry Ford
          </h4>-->
        </div>
      </div>
    </div>

    <div v-if="selectedTab=='Performance Management'" class="container" id="performancemngmt">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">PERFORMANCE MANAGEMENET</h3>
        </div>
      </div>
      <div class="cardTxt text-left">
        <div class="m-auto">
          <br />
          <p
            class="font-weight-bold mb-1"
            style="font-size:18px;"
          >Each of the orders either Purchase or Service will be assessed in the following parameters</p>

          <!-- <h3 class="mt-2 font-weight-bold pl-4 pt-2">Collation of feedback on the aspects like</h3> -->
          <div>
            <Ul class="ml-4" style="margin-left:70px">
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span class="font-weight-bold" style="font-size:16px;">Cost</span>
                <!-- </p> -->
              </li>
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span class="font-weight-bold" style="font-size:16px;">Quality</span>
                <!-- </p> -->
              </li>
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span class="font-weight-bold" style="font-size:16px;">Delivery & Responsiveness</span>
                <!-- </p> -->
              </li>
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >Partnership / Innovation ] Specific to PO</span>
                <!-- </p> -->
              </li>
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span class="font-weight-bold" style="font-size:16px;">EHS and Compliance related }</span>
                <!-- </p> -->
              </li>
              <li>
                <!-- <p class="font-weight-bold"> -->
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >General & admin } Specific to WO</span>
                <!-- </p> -->
              </li>
            </Ul>
          </div>
          <div>
            <!-- <li> -->
            <p
              class="font-weight-bold mb-1"
              style="font-size:18px;"
            >Based on the material classification, the above parameters are assigned different weightage and different question</p>
            <!-- </li> -->
            <ul class="ml-4">
              <li>
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >The question are classified into three types based on the input source.</span>
              </li>
              <ol class="font-weight-bold ml-2" style="font-size:16px;">
                <li>E-External</li>
                <li>S- System</li>
                <li>U - User Input</li>
              </ol>
              <li>
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >All the answered will be scaled between 1-5</span>
              </li>
              <li>
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >Scoring methodology is defined for each scenario against each metricn</span>
              </li>
              <li>
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >After assessing each PO, a vendor composite score will be calculated for that PO /WO</span>
              </li>
              <li>
                <span
                  class="font-weight-bold"
                  style="font-size:16px;"
                >Overall vendor will be calculated on the basis of weighted cumulative score of the all the PO / WO</span>
              </li>
            </ul>
          </div>

          <p class="row">
            <span
              class="col-1 text-center font-weight-bold"
              style="background-color:#00b33c;border-style: ridge;"
            >>75%</span>
            <span
              class="col font-weight-bold"
            >Vendor's performance meets criteria and is eligible to participate in procurement/Service</span>
          </p>
          <p class="row">
            <span
              class="col-1 text-center font-weight-bold"
              style="background-color:yellow;border-style: ridge;"
            >>50% &lt; 75%</span>
            <span class="col font-weight-bold">Vendor's performance needs to be evaluated</span>
          </p>
          <p class="row">
            <span
              class="col-1 text-center font-weight-bold"
              style="background-color:red;border-style: ridge;"
            >&lt; 50%</span>
            <span
              class="col font-weight-bold"
            >Vendor's performance is not up to expectation ,not eligible to participate in procurement / Service</span>
          </p>

          <!--  <h4 class="ml-4 font-weight-bold pb-3">Phase II : Specification Review ; WIP</h4> -->
        </div>
      </div>
      <!-- </div> -->
    </div>

    <div v-if="selectedTab=='Feedback Questionnaire'" class="container" id="partnerfeedback">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">PARTNER FEEDBACK</h3>
        </div>
      </div>
      <div class="cardTxt text-left">
        <div class="m-auto">
          <h4
            class="pt-3 pl-4"
            style="font-size:18px"
          >As a step towards strengthening the partner relationship, this section is designed to capture the information about the job to which the partner has rendered services.</h4>

          <h3 class="mt-1 font-weight-bold pl-4 pt-2">Collation of feedback on the aspects like</h3>
          <Ol class="ml-4">
            <li>
              <span
                class="font-weight-bold"
                style="font-size:16px;"
              >User Experience Example: Ease of doing business during RFQ to Contract, Contract to Pay etc.</span>
            </li>
            <li>
              <span class="font-weight-bold" style="font-size:16px;">Issue Resolution Experience</span>
            </li>
            <li>
              <span class="font-weight-bold" style="font-size:16px;">Communication</span>
            </li>
          </Ol>
          <p
            class="font-weight-bold m-0 p-0 ml-4 mr-2"
            style="font-size:18px;"
          >Governance mechanism in terms of Evaluation Frequency, Escalation Matrix, Mode of communication i.e. who will evaluate whom and When, is also being planned.</p>

          <!--  <h4 class="ml-4 font-weight-bold pb-3">Phase II : Specification Review ; WIP</h4> -->
        </div>
      </div>
      <!-- </div> -->
    </div>

    <div v-if="selectedTab=='Price Discovery'" class="container" id="pricediscvry">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">PRICE DISCOVERY</h3>
        </div>
      </div>
      <div class="cardTxt text-left">
        <div class="m-auto ml-3 mr-4 mb-2">
          <br />
          <span
            class="font-weight-bold"
            style="font-size:15px;"
          >Price discovery is the central function of a marketplace and is the process of finding out the price of a given asset or commodity or service.</span>
          <span
            class="font-weight-bold"
            style="font-size:15px;"
          >Price discovery is what gets a specific buyer and specific partner to move from a establishing a general price to agreeing on a specific price for their transaction, based on the size of the transaction, location of the transaction, cost of the transaction, etc..</span>
          <span class="font-weight-bold" style="font-size:15px;">
            L&T Market place would enable the business user to explore and get to know the price details updated by the partner and in turn partner would also get to know the requirement for which he might be able serve.
            <br />
          </span>
          <br />
          <!--  <h4 class="ml-4 mt-4 font-weight-bold pb-3">Phase II : Specification Review ; WIP</h4>  -->
        </div>
      </div>
      <!-- </div> -->
    </div>

    <div v-if="selectedTab=='Catalogue Management'" class="container" id="catalogue">
      <div class="row">
        <div class="col heading my-3">
          <h3 class="float-right stretched-side-headings">CATALOGUE MANAGEMENT</h3>
        </div>
      </div>
      <div class="cardTxt text-left">
        <div class="m-auto">
          <h3 class="mt-2 font-weight-bold pl-4 pt-3">Catalogue Management is to</h3>
          <br />
          <ul class="ml-3">
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Build a smart, accessible and neat catalogue for products</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Leverage the benefits of great content, to suit business</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Reduce manual efforts by 80% and streamlines the data format. Thus, keeping the information consistent and updated across various channels</span>
            </li>
            <li>
              <span class="font-weight-bold" style="font-size:18px;">Scale and plan digital presence</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Adapt listing to meet requirements specific to each marketplace</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Make it easier for business users to navigate through products and make optimum use of well-maintained product range</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Set up notifications on specific events – reduced the dependence on email and offline communication.</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >To interact with external systems easily – standardizations help easy data transfer in and out the system used by partner [suppliers / service providers]</span>
            </li>
            <li>
              <span
                class="font-weight-bold"
                style="font-size:18px;"
              >Make the system consistent and easy to use across the organization. Everybody will be seeing not just the latest information and but the same information across all departments. This ensures that decisions are taken based on current status rather than outdated information</span>
            </li>
          </ul>
          <p
            class="font-weight-bold"
            style="font-size:18px;"
          >A Catalogue Management system helps to leverage the benefits of making decisions based on current information. This eventually translates into a better experience for the partners.</p>

          <!-- <h4 class="ml-4 font-weight-bold pb-3">Phase II : Specification Review ; WIP</h4>  -->
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div v-if="selectedTab=='testimonials'" class="container" id="testimonial">
      <div class="row">
        <div class="col heading my-3 ml-0">
          <h3 class="text-left stretched-side-headings">TESTIMONIALS</h3>
        </div>
      </div>
      <vueper-slides
        class="no-shadow mx-3 ml-1 mr-2"
        :visible-slides="3"
        slide-multiple
        :gap="3"
        fixed-height="480px"
        :bulletsOutside="false"
        :bullets="false"
        :autoplay="true"
        :slide-ratio="1 / 4"
        :dragging-distance="100"
        :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
      >
        <template v-slot:arrow-left>
          <img src="@/assets/arrow_back.svg" />
        </template>

        <template v-slot:arrow-right>
          <img src="@/assets/arrow_forward.svg" />
        </template>
        <vueper-slide v-for="(data,i) in approvedTestimonialsArray" :key="i">
          <template v-slot:content>
            <div class="card certificate-card mb-4 p-0">
              <div class="m-0 p-0" style="height:100px;background-color:#b4c9f8;"></div>
              <div class="m-0 p-0" style="margin-top:-65px !important;">
                <div
                  class="border ml-4 pb-0 pt-3"
                  style="width:110px;height:110px;background-color:white;border-radius:49%"
                >
                  <!-- <img alt style="width:65%;height:73%;" /> -->
                  <img
                    class="card-img"
                    style="width:65%;height:80%;"
                    :src="getCompanyImageLogo(data.testimonialDocId, i)"
                  />
                </div>
              </div>
              <div class="row m-0 p-0 mt-4">
                <div class="col-2"></div>
                <div class="col-8 text-left ml-n4">
                  <img
                    src="@/assets/home-page-images/invertedLeft.png"
                    alt
                    style="height:16px;width:20px;"
                  />
                </div>
                <div class="col-2"></div>
              </div>
              <div class="row m-0 p-0">
                <div class="col-2 m-0 p-0"></div>
                <div class="col-8 m-0 p-0">
                  <div class="m-0 p-2 ml-2 text-left testimonialsDescription">{{data.testimonials}}</div>
                  <div class="m-0 pl-2 ml-2 text-left testimonialsName mt-4">{{data.companyName}}</div>
                  <div class="m-0 pl-2 ml-2 text-left testimonialsDesignation">{{data.designation}}</div>
                </div>
              </div>
              <br />
              <!-- <div class="col-2 m-0 p-0"></div> -->
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
      <!-- <div class="row animate-area">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <div class="row">
              <div class="col-sm-5 p-0 cardTxt">
                <div class="pl-4 pr-3 pt-4 mt-2 pb-4">
                  <div class="row m-0 px-5">
                    <img src="@/assets/home-page-images/invertedLeft.png" alt />
                  </div>
                  <p
                    class="px-5 font-weight-bold"
                  >The portal is well designed and captures all relevant information. The interface is user friendly and easy to navigate</p>
                  <div class="row m-0 float-right px-5">
                    <img src="@/assets/home-page-images/invertedRight.png" alt />
                  </div>
                </div>
                <div class="heading">
                  <h3 class="px-5 text-left font-weight-bold">Tata Steel</h3>
                </div>
                <div class="row">
                  <div class="col-4 ml-5 mt-4 pt-4">
                    <div class="swiper-button-prev ml-1 px-5" slot="button-prev"></div>
                    <div class="swiper-button-next mr-3 px-0" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-7 aboutImg">
                <img src="@/assets/images/tataSteel.png" alt />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="row">
              <div class="col-sm-5 p-0 cardTxt">
                <div class="pl-4 pr-3 pt-4 mt-2 pb-4">
                  <div class="row m-0 px-5">
                    <img src="@/assets/home-page-images/invertedLeft.png" alt />
                  </div>
                  <p
                    class="px-5 font-weight-bold"
                  >The existing website is user friendly .The new system developed is also more user friendly and highly informative and we hope that it will serve all the needs of the vendors</p>
                  <div class="row m-0 float-right px-5">
                    <img src="@/assets/home-page-images/invertedRight.png" alt />
                  </div>
                </div>
                <div class="heading">
                  <h3 class="px-5 text-left font-weight-bold">Ramco Cements</h3>
                </div>
                <div class="row">
                  <div class="col-4 ml-5 mt-4 pt-4">
                    <div class="swiper-button-prev ml-1 px-5" slot="button-prev"></div>
                    <div class="swiper-button-next mr-3 px-0" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-7 aboutImg">
                <img src="@/assets/images/ramco.png" alt />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="row">
              <div class="col-sm-5 p-0 cardTxt">
                <div class="pl-4 pr-3 pt-4 mt-2 pb-4">
                  <div class="row m-0 px-5">
                    <img src="@/assets/home-page-images/invertedLeft.png" alt />
                  </div>
                  <p
                    class="px-5 font-weight-bold"
                  >L&T vendor portal is much superior compared to that of other companies</p>
                  <div class="row m-0 float-right px-5">
                    <img src="@/assets/home-page-images/invertedRight.png" alt />
                  </div>
                </div>
                <div class="heading">
                  <h3 class="px-5 text-left font-weight-bold">Ultratech Cements</h3>
                </div>
                <div class="row">
                  <div class="col-4 ml-5 mt-4 pt-4">
                    <div class="swiper-button-prev ml-1 px-5" slot="button-prev"></div>
                    <div class="swiper-button-next mr-3 px-0" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-7 aboutImg">
                <img src="@/assets/images/ultratech.png" alt />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="row">
              <div class="col-sm-5 p-0 cardTxt">
                <div class="pl-4 pr-3 pt-4 mt-2 pb-4">
                  <div class="row m-0 px-5">
                    <img src="@/assets/home-page-images/invertedLeft.png" alt />
                  </div>
                  <p
                    class="px-5 font-weight-bold"
                  >This system will be very useful for us to grow business with L&T in all divisions with one vendor code</p>
                  <div class="row m-0 float-right px-5">
                    <img src="@/assets/home-page-images/invertedRight.png" alt />
                  </div>
                </div>
                <div class="heading">
                  <h3 class="px-5 text-left font-weight-bold">SV Civcons Pvt Ltd</h3>
                </div>
                <div class="row">
                  <div class="col-4 ml-5 mt-4 pt-4">
                    <div class="swiper-button-prev ml-1 px-5" slot="button-prev"></div>
                    <div class="swiper-button-next mr-3 px-0" slot="button-next"></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-7 aboutImg">
                <img src="@/assets/home-page-images/testimonial.png" alt />
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>-->
    </div>
    <div
      v-if="selectedTab=='suggestions'"
      class="container suggestion-content-div"
      id="suggestions"
    >
      <div class="suggestions-info-div">
        <div class="h-50">
          <!-- <img class="mt-3 ml-4 m-0 p-0 row" src="../../assets/images/lntLogo.svg" />
          <span class="row ml-4 mt-3 source-sans-pro f-about-lnt">About L&T Construction</span>-->
          <span class="row ml-4 mt-4 source-sans-pro f-suggestions-heading">Suggestions & Feedback</span>
          <span class="row ml-4 mt-2 source-sans-pro f-about-lnt">We want to hear from you</span>
          <span
            class="row ml-4 mt-2 source-sans-pro f-experience-improve"
          >Tell us about your experience and feedback to improve our service</span>
          <!-- <span class="row ml-4 mb-5 source-sans-pro f-experience-improve">To improve our service</span> -->
        </div>
        <div class="h-50">
          <img class="mt-5 m-0 p-0 suggestions-last-img" src="../../assets/mask_group.svg" />
        </div>
      </div>
      <div class="feedback-fields-div">
        <div class="row mt-3" onpaste="return false">
          <div class="col-6">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Name">
              <w-text-input
                class="text-left"
                @textInputChange="getFBProviderName($event)"
                validation="required"
                :allowOnlyCharacters="true"
                :maxCharacter="'100'"
                :defaultValue="FbpName"
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Designation">
              <w-text-input
                class="text-left"
                @textInputChange="getFBProviderDesignation($event)"
                validation="required"
                :allowOnlyCharacters="true"
                :maxCharacter="'100'"
                :defaultValue="FbpDesignation"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row" onpaste="return false">
          <div class="col-12">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Company">
              <w-text-input
                class="text-left"
                @textInputChange="getFBProviderCompany($event)"
                validation="required"
                :allowOnlyCharacters="true"
                :maxCharacter="'100'"
                :defaultValue="FbpCompany"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row" onpaste="return false">
          <div class="col-6">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Email">
              <w-text-input
                class="text-left"
                @textInputChange="getFBProviderEmail($event)"
                validation="required|email"
                :maxCharacter="'100'"
                :defaultValue="FbpEmail"
              />
              <p
                class="ml-3 font-weight-bold text-danger lato-regular"
                v-if="validEmail"
              >Email must be a valid email.</p>
              <p
                class="ml-3 font-weight-bold text-danger lato-regular"
                v-if="restrictEmail"
              >Email ID of this domain is Restricted!</p>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Mobile Number">
              <w-text-input
                class="text-left"
                :inputAdditions="'mobile'"
                validation="required|regex_mobile_number"
                @textInputChange="getFBProviderMobile($event)"
                :type="'number'"
                :maxDigits="'10'"
                :defaultValue="FbpMobile"
              />
              <p
                class="ml-3 font-weight-bold text-danger lato-regular"
                v-if="validMobile"
              >Mobile Number must contain only 10 digits and Starting Number should not be 0.</p>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Remarks">
              <w-text-area
                :rows="4"
                @inputChanges="getFBProviderRemarks($event)"
                @keydown="checkRemarksKeyDown($event)"
                validation="required"
                :maxCharacter="'1000'"
                :defaultValue="FbpRemarks"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group class="source-sans-pro text-left bold ml-3 mr-3" label="Rating">
              <VueFeedbackReaction v-model="feedbackScaleValue" class="feedback-rating" />
              <div
                class="text-left source-sans-pro bold"
                :class="ratingColor(feedbackScaleValue)"
              >{{ratingDesc[feedbackScaleValue-1]}}</div>
            </b-form-group>
          </div>
          <!-- <div
            class="col-4 mt-5 pt-2 text-left source-sans-pro bold"
            :class="ratingColor(feedbackScaleValue)"
          >{{ratingDesc[feedbackScaleValue-1]}}</div>-->
        </div>
        <div class>
          <b-button
            @click="submitFeedback()"
            class="btn-feedback-proceed source-sans-pro m-3"
            :disabled="allFeedbackFieldsPresent()"
          >Submit</b-button>
        </div>
      </div>
    </div>
    <div id="career" class="text-center">
      <h2 class="heading stretched-side-headings">JOIN OUR TEAM</h2>
      <p
        class="cTxt"
      >Let’s work together to built great Infrastructure that enhances how people live, work, learn and play in our society.</p>
      <b-button data-aos="zoom-out" @click="goToRegisterPage()">
        Register
        <img src="@/assets/home-page-images/footerRight.png" alt />
      </b-button>
    </div>
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="closeTriggerdModal()"
    />
  </div>
</template>

<script>
import AOS from "aos";
import { VueperSlides, VueperSlide } from "vueperslides";
import { PartnerService } from "../../services/partnerService";
const PartnerServices = new PartnerService();
import TextInput from "../../widgets/TextInput";
import Textarea from "../../widgets/TextArea";
import { VueFeedbackReaction } from "vue-feedback-reaction";
import { RegistrationService } from "../../services/RegistrationService.js";
const RegisterService = new RegistrationService();
import Modal from "../../widgets/newModalWidget";

export default {
  components: {
    VueperSlides,
    VueperSlide,
    "w-text-input": TextInput,
    "w-text-area": Textarea,
    VueFeedbackReaction,
    "w-modal": Modal
  },
  props: ["selectedTab"],
  name: "aboutUs",
  data() {
    return {
      activeFirst: 0,
      activeSecond: 1,
      activeThird: 2,
      approvedTestimonialsArray: [],
      image: undefined,
      imageBind: [],
      imageTempArray: [],

      testimonialsArray: [
        {
          image: "tata",
          description:
            "The portal is well designed and captures all relevant information. The interface is user friendly and easy to navigate",
          name: "Tata Steel",
          designation: "Manager, Tata Steel"
        },
        {
          image: "ramco",
          description:
            "The existing website is user friendly .The new system developed is also more user friendly and highly informative and we hope that it will serve all the needs of the vendors",
          name: "Ramco Cement",
          designation: "Manager, Ramco Cement"
        },
        {
          image: "adityabirla",
          description:
            "L&T vendor portal is much superior compared to that of other companies",
          name: "Aditya Brila Groups",
          designation: "Manager, Aditya Brila Groups"
        },
        {
          image: "",
          description:
            "This system will be very useful for us to grow business with L&T in all divisions with one vendor code",
          name: "SV Civicons Pvt Ltd",
          designation: "Manager, Ramco Cement"
        }
      ],
      FbpName: "",
      FbpCompany: "",
      FbpDesignation: "",
      FbpMobile: "",
      FbpEmail: "",
      FbpRemarks: "",
      feedbackScaleValue: "",
      validMobile: false,
      validEmail: false,
      restrictEmail: false,
      triggerModal: false,
      successModal: false,
      lastResponse: "",
      ratingDesc: ["Very Bad", "Bad", "Ok", "Good", "Very Good"]
    };
  },
  created() {
    // document.scrollingElement.scrollTop = 0;
    this.getApprovedTestimonials();
  },
  watch: {
    selectedTab: function() {
      if (this.selectedTab != "suggestions") {
      } else {
        this.clearFeedbackFields();
      }
    }
  },
  methods: {
    move(amount) {},
    goToRegisterPage() {
      this.$router.push("/registration");
    },
    getSlides() {
      var screenSize = screen.availWidth;
      if (screenSize >= 1901) {
        return "4";
      } else if (screenSize >= 1366 && screenSize <= 1900) {
        return "3";
      } else if (screenSize >= 1280) {
        return "3";
      }
    },
    getImage(icon) {
      if (icon) {
        var images = require.context("@/assets/Icons/", false, /\.png$/);
        return images("./" + icon + ".png");
      } else {
        var images = require.context("@/assets/Icons/", false, /\.svg$/);
        return images("./" + "user" + ".svg");
      }
    },
    getTestimonialsImage(icon) {
      if (icon) {
        var images = require.context(
          "@/assets/home-page-images/testimonials/",
          false,
          /\.svg$/
        );
        return images("./" + icon + ".svg");
      }
    },
    getApprovedTestimonials() {
      PartnerServices.getApprovedTestimonials()
        .then(res => {
          this.approvedTestimonialsArray = res.response;
          for (let j = 0; j < res.response.length; j++) {
            let resImage = null;
            let tempImageBind = {
              image: undefined,
              docId: ""
            };
            let docId = res.response[j].testimonialDocId;

            PartnerServices.downloadCompanyLogo(docId).then(res => {
              this.image = res;
              resImage = this.image;
              var uInt8Array = new Uint8Array(resImage);

              var i = uInt8Array.length;
              var biStr = new Array(i);
              while (i--) {
                biStr[i] = String.fromCharCode(uInt8Array[i]);
              }
              var data = biStr.join("");
              var base64 = window.btoa(data);
              // let tempImage = "data:image/jpeg;base64," + base64;
              this.imageTempArray.push("data:image/jpeg;base64," + base64);
              tempImageBind.image = "data:image/jpeg;base64," + base64;
              tempImageBind.docId = docId;
              this.imageBind.push(tempImageBind);
            });
          }
          // console.log(res);
          console.log(this.imageBind);
        })
        .catch(err => {
          console.log(`Error Occured ${err}`);
        });
    },
    getCompanyImageLogo(docId, i) {
      //console.log("imageArray:", this.imageTempArray[i]);
      for (let j = 0; j < this.imageBind.length; j++) {
        if (this.imageBind[j].docId == docId) {
          return this.imageBind[j].image;
        }
      }
      //this.loading = false;
      // return this.imageTempArray[i];
    },
    getFBProviderName(event) {
      this.FbpName = event;
    },
    getFBProviderCompany(event) {
      this.FbpCompany = event;
    },
    getFBProviderDesignation(event) {
      this.FbpDesignation = event;
    },
    getFBProviderMobile(event) {
      if (event.length < 10) {
        this.validMobile = true;
      } else {
        this.validMobile = false;
      }
      this.FbpMobile = event;
    },
    getFBProviderEmail(event) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      let emailRegex = new RegExp(
        "^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"
      );
      if (!event.includes("@") || !event.includes(".")) {
        this.validEmail = true;
        this.restrictEmail = false;
      } else if (emailRegex.test(event.toLowerCase())) {
        this.validEmail = false;
        var domain = event.replace(/.*@/, "");
        var domainName = domain.split(".");
        if (domainName[0]) {
          RegisterService.restrictEmail(domainName[0]).then(resp => {
            if (resp.response == false) {
              this.restrictEmail = true;
            } else {
              this.restrictEmail = false;
            }
          });
        }
      }
      this.FbpEmail = event;
    },
    getFBProviderRemarks(event) {
      this.FbpRemarks = event;
    },
    checkRemarksKeyDown(event) {
      if (event.key == "Tab") {
        event.preventDefault();
        return false;
      }
    },
    submitFeedback() {
      
      var feedbackRequest = {
        feedbackerName: this.FbpName,
        feedbackerCompany: this.FbpCompany,
        feedbackerDesignation: this.FbpDesignation,
        feedbackerMobile: this.FbpMobile,
        feedbackerEmail: this.FbpEmail,
        feedbackerRemarks: this.FbpRemarks,
        feedbackerScaleRating: this.feedbackScaleValue
      };
      PartnerServices.savePartnerFeedbackSuggestions(feedbackRequest)
        .then(res => {
          if (res.response) {
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse =
              "Your Suggestions & Feedback submitted Successfully";
          }
        })
        .catch();
    },
    clearFeedbackFields() {
      this.FbpName = "";
      this.FbpCompany = "";
      this.FbpDesignation = "";
      this.FbpMobile = "";
      this.FbpEmail = "";
      this.FbpRemarks = "";
      this.feedbackScaleValue = "";
      this.validEmail = false;
      this.restrictEmail = false;
      this.validMobile = false;
    },
    allFeedbackFieldsPresent() {
      if (
        this.FbpName &&
        this.FbpCompany &&
        this.FbpDesignation &&
        this.FbpMobile &&
        this.FbpEmail &&
        this.FbpRemarks &&
        this.feedbackScaleValue &&
        this.validMobile == false &&
        this.validEmail == false &&
        this.restrictEmail == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    closeTriggerdModal() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
      this.clearFeedbackFields();
      location.reload();
    },
    ratingColor(event) {
      if (event == 1) {
        return "very-bad-class";
      } else if (event == 2) {
        return "bad-class";
      } else if (event == 3) {
        return "ok-class";
      } else if (event == 4) {
        return "good-class";
      } else {
        return "very-good-class";
      }
    }
  }
};
</script>

<style scoped>
#aboutLnt {
  scroll-behavior: smooth;
  padding-top: 5px;
  background-color: #002257;
}
.heading {
  font-weight: 700;
  font-family: "Open Sans Condensed", sans-serif;
  color: white;
  text-transform: uppercase;
  letter-spacing: 4px;
  padding: 0;
}
.ftrHeading {
  font-weight: bold;
  color: #002d72;
  margin: 5rem auto 20px 30px;
  font-size: 26px;
  letter-spacing: normal;
}
.aboutImg {
  padding: 0;
}
.aboutImg img {
  height: 600px;
  width: 100%;
}
.cardTxt {
  background-color: #b4c9f8;
  font-family: "Open Sans", sans-serif !important;
}
.cardTxt p {
  margin: 35px 30px;
  font-weight: 400;
  color: #242424;
  text-align: justify;
}
#catalogue .cardTxt {
  font-size: 16px;
}
#partnerfeedback .cardTxt {
  font-size: 16px;
}
.cardTxt a,
.cardTxt a:hover {
  font-family: "Open Sans Condensed", sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  color: #002d72;
  letter-spacing: 2px;
  font-weight: bold;
  font-size: 14px;
}
#partner .cardTxt h3 {
  font-size: 22px;
  color: #002d72;
}
#partner .cardTxt li {
  font-size: 16px;
  list-style: none;
  margin: 25px auto;
  color: #242424;
}
#partner .cardTxt {
  padding: 60px 40px;
}
#partner .cardTxt ul {
  padding: 0;
}
#partner .cardTxt p {
  margin: 15px 5px;
}
#mplace .cardTxt p,
#Wpartner .cardTxt p {
  text-align: left;
  font-size: 15px;
  margin: 16px 5px;
}
#mplace .mHeading,
.pHeading {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #002d72;
  letter-spacing: normal;
  margin-left: 5px;
}
#mplace ul {
  list-style: none;
  padding: 0;
  margin-left: 5px;
  font-size: 14px;
}
#testimonial .m-0 img {
  width: 30px;
}
/* #testimonial .cardTxt p {
   margin: 10px 30px; 
} */
#testimonial .heading {
  color: #002d72;
  letter-spacing: normal;
  font-family: "Titillium Web", sans-serif;
  font-weight: 600;
  margin-left: 3.3rem;
}
#testimonial .heading h3 {
  /* font-size: 20px; */
  text-transform: capitalize;
}
#testimonial .heading h5 {
  font-size: 14px;
}
#career {
  padding-bottom: 5rem;
}
#career .heading {
  font-size: 40px;
  margin-top: 5rem;
  margin-bottom: 2rem;
  letter-spacing: 7px;
}
#career .cTxt {
  width: 50%;
  color: white;
  font-weight: 300;
  opacity: 0.6;
  font-size: 20px;
  margin: 0 auto;
  margin-bottom: 4rem;
}
#career .btn-secondary,
#career .btn-secondary:hover,
#career .btn-secondary:focus,
#career .btn-secondary:active {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none;
  color: white !important;
  padding-left: 0;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  letter-spacing: 2.5px;
  font-size: 18px;
}
#career .btn-secondary img {
  width: 18px;
  margin-left: 5px;
  margin-bottom: 2px;
}
/* .swiper-slide {
  color: #fff;
} */
/* .swiper-button-prev {
  background-image: url("../../assets/home-page-images/leftIcon.png");
  background-size: 40px;
} */
/* .swiper-button-next {
  background-image: url("../../assets/home-page-images/rightIcon.png");
  background-size: 40px;
} */
.stretched-side-headings {
  font-family: "Open Sans";
  font-size: 40px;
  font-weight: bold;
  font-style: normal;
  font-stretch: condensed;
  text-transform: capitalize;
  line-height: 1.38;
  letter-spacing: 8px;
  color: var(--white);
}
.animate-area:hover {
  /* transform: scale(1.05) !important; */
}
.testimonialsName {
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 1.28;
  text-align: right;
  color: #002d72;
  font-weight: bold;
}
.testimonialsDesignation {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 1.29;
  text-align: right;
  color: #848484;
}
.testimonialsDescription {
  height: 200px !important;
  font-family: "Source Sans Pro", sans-serif;
}
.testimonialRowPadding {
  padding: 0px 180px 0px 180px !important;
  margin-left: 1px !important;
  margin-right: 1px !important;
}
@media (max-width: 1900px) {
  .testimonialRowPadding {
    padding: 0px 0px 0px 0px !important;
    margin-left: 1px !important;
    margin-right: 1px !important;
  }
}
@media (max-width: 1263px) {
  .testimonialRowPadding {
    padding: 0px 0px 0px 0px !important;
    margin-left: -80px !important;
    margin-right: -70px !important;
  }
}
@media (max-width: 1145px) {
  .testimonialRowPadding {
    padding: 0px 0px 0px 0px !important;
    margin-left: -60px !important;
    margin-right: -50px !important;
  }
}
@media (max-width: 1100px) {
  .testimonialRowPadding {
    padding: 0px 0px 0px 0px !important;
    margin-left: -25px !important;
    margin-right: -10px !important;
  }
}
.prev {
  position: absolute;
  top: 50%;
  left: 0%;
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  color: #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-left: 25px;
  cursor: pointer;
  line-height: 48px;
  text-align: center;
  text-indent: -2px;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.next {
  position: absolute;
  top: 50%;
  right: 0%;
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  color: #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-left: 25px;
  cursor: pointer;
  line-height: 48px;
  text-align: center;
  text-indent: -2px;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.prev:hover,
.next:hover {
  /* background: #fff;
  color: #fff; */
  transform: scale(1.2);
}

.prev:active,
.next:active {
  /* transform: translate(0, 3px) scale(1.2); */
}

.next {
  right: 0;
  margin-left: auto;
  margin-right: 25px;
  text-indent: 2px;
}

.slides {
  /* font-size: 40px; */
  display: flex;
  /* height: 100%; */
  /* align-items: center; */
  /* justify-content: center; */
  /* font-weight: bold; */
}
.animated {
  transition: all 100ms;
  /* position: relative; */
  /* transform: translate(-50%, -50%); */
}

.slide-in {
  opacity: 0;
  /* transform: translate(-40%, -50%); */
}

.slide-in-active {
  transition-delay: 100ms;
}

.slide-out {
  opacity: 1;
  display: none;
}

.slide-out-active {
  opacity: 0;
  display: none;
  /* transform: translate(-60%, -50%); */
}
.suggestions-info-div {
  float: left;
  width: 50%;
  height: 100% !important;
  background-color: #f0fff0;
}
.feedback-fields-div {
  float: left;
  width: 50%;
  height: 100% !important;
  background-color: #fffafa;
}
.f-about-lnt {
  font-size: 18px;
  font-weight: bold;
}
.f-suggestions-heading {
  font-size: 40px;
  font-weight: 700;
}
.f-experience-improve {
  font-size: 16px;
}
.div-feedback-submit {
  height: 40px;
  color: white !important;
  border-radius: 2px;
  background-color: #333f6b;
}
.btn-feedback-proceed {
  font-size: 17px;
  background-color: #333f6b;
  width: 90%;
}
.suggestion-content-div {
  height: 750px;
}
.suggestions-last-img {
  max-width: 100% !important;
  max-height: 100% !important;
}
.very-bad-class {
  color: red;
  font-size: 17px;
  font-weight: 600;
  filter: brightness(150%);
  padding-left: 1%;
}
.bad-class {
  color: orange;
  font-size: 17px;
  font-weight: 600;
  padding-left: 18%;
}
.ok-class {
  color: darkorange;
  font-size: 17px;
  font-weight: 600;
  filter: brightness(150%);
  padding-left: 33%;
}
.good-class {
  color: lime;
  font-size: 17px;
  font-weight: 600;
  filter: brightness(150%);
  padding-left: 45%;
}
.very-good-class {
  color: darkgreen;
  font-size: 17px;
  font-weight: 600;
  filter: brightness(150%);
  padding-left: 56%;
}
.feedback-rating:hover {
}
</style>